import http from '../../utils/httpService';
import { API_SETTINGS_ROUTE, API_ZAPIER_KEY_ROUTE, API_ZAPIER_DISCONNECT_ROUTE } from './constants';

/**
 *
 * @param form
 * @returns {*}
 */
const sendApiSettings = form => (
    http.request( API_SETTINGS_ROUTE, 'PUT', form, false )
);
/**
 *
 * @returns {*}
 */
const getApiSettings = () => (
    http.request( API_SETTINGS_ROUTE, 'GET', null, false )
);

const putApiZapierKey = () => (
    http.request( API_ZAPIER_KEY_ROUTE, 'GET', null, false )
);

const putApiZapierDisconnect = () => (
    http.request( API_ZAPIER_DISCONNECT_ROUTE, 'put', null, false )
);


export { sendApiSettings,  getApiSettings, putApiZapierKey, putApiZapierDisconnect };